// extracted by mini-css-extract-plugin
export default {"optIcon":"Operator_optIcon__8qK7V","opt":"Operator_opt__BZhmK","iconBtn":"Operator_iconBtn__Nudja","iconActive":"Operator_iconActive__Imwn+"};